import { createStore } from "vuex";
import themeLayout from "./modules/themeLayout/actionCreator";
import headerSearchData from "./modules/headerSearch/actionCreator";
import auth from "./modules/authentication/axios/actionCreator";
import xeroclient from "./modules/xeroclient/actionCreator";
import UserMaster from "./modules/usermaster/actionCreator";
import RoleMaster from "./modules/rolemaster/actionCreator";
import AdminMaster from "./modules/adminmaster/actionCreator";

export default createStore({
  modules: {
    themeLayout,
    headerSearchData,
    auth,
    xeroclient,
    UserMaster,
    RoleMaster,
    AdminMaster,
  },
});
